import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, TextArea, RadioGroup } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function WaysOfWorkingPage() {
  const [decisionStyle, setDecisionStyle] = useState('');
  const [planningRhythm, setPlanningRhythm] = useState('');
  const [standups, setStandups] = useState('');
  const [scopeChange, setScopeChange] = useState('');
  const [definitionOfDone, setDefinitionOfDone] = useState('');
  const [communicationChannels, setCommunicationChannels] = useState('');
  const [workingAgreements, setWorkingAgreements] = useState('');

  return (
    <TaskPage
      phase="engage"
      title="Ways of Working"
      pageNumber={5}
      instruction="How we'll actually operate. Define decision style, cadence, rituals, and working agreements."
      whyItMatters="Worked examples + explicit rules are classic scaffolds—gradually removable as the team internalizes them."
      coachRail={{
        timing: "10 minutes",
        tips: "Be specific about decision-making and communication. Ambiguity creates confusion.",
        debrief: "What agreements do we need to revisit? What's missing?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Decision Style</h3>
          <RadioGroup
            label="How do we make decisions?"
            options={[
              { value: 'RACI', label: 'RACI' },
              { value: 'DACI', label: 'DACI' },
              { value: 'disagree-commit', label: '"Disagree & commit"' },
              { value: 'other', label: 'Other (specify below)' }
            ]}
            value={decisionStyle}
            onChange={setDecisionStyle}
          />
          {decisionStyle === 'disagree-commit' && (
            <TextArea
              label="How we decide when we disagree"
              placeholder="Describe the process..."
              rows={3}
              className="mt-4"
            />
          )}
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Cadence & Rituals</h3>
          <div className="space-y-4">
            <TextInput
              label="Planning / review rhythm"
              value={planningRhythm}
              onChange={(e) => setPlanningRhythm(e.target.value)}
              placeholder="e.g., Weekly on Mondays"
            />
            <TextInput
              label="Standups / check-ins"
              value={standups}
              onChange={(e) => setStandups(e.target.value)}
              placeholder="e.g., Daily at 9am"
            />
            <TextInput
              label="Who must be in the room to change scope"
              value={scopeChange}
              onChange={(e) => setScopeChange(e.target.value)}
              placeholder="Names or roles"
            />
            <TextArea
              label="Definition of 'done' for this cycle"
              value={definitionOfDone}
              onChange={(e) => setDefinitionOfDone(e.target.value)}
              placeholder="What does 'done' mean?"
              rows={3}
            />
            <TextArea
              label="Communication channels"
              value={communicationChannels}
              onChange={(e) => setCommunicationChannels(e.target.value)}
              placeholder="Where updates & docs live; where decisions are recorded"
              rows={3}
            />
          </div>
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Working Agreements</h3>
          <TextArea
            label="Team agreements (3 lines max)"
            value={workingAgreements}
            onChange={(e) => setWorkingAgreements(e.target.value)}
            placeholder='e.g., "no new work without a slice & owner," "meeting hygiene"'
            rows={4}
            helpText="Keep it concise and actionable"
          />
        </div>

        <Callout type="tip" phase="engage">
          <p className="text-sm">Examples: "no new work without a slice & owner," "meeting hygiene," "decision timeboxes"</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






